import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import DefaultCard from '../../../components/DefaultCard';
import IconButton from '../../../components/IconButton';
import Link from '../../../components/Link';
import ModalHeader from '../../../components/ModalHeader';
import { RadioGroup } from '../../../components/Radio';
import SelectableCard from '../../../components/SelectableCard';
import { EnrollmentStore } from '../../../providers/enrollment';
import { getAllLegalServices } from '../../../services/enrollment';

export type customLegalServicesModalProps = {
  showLegalServicesModal: boolean;
  handleCloseLegalServicesModal: () => void;
};

const LegalServicesModal = ({
  showLegalServicesModal,
  handleCloseLegalServicesModal,
}: customLegalServicesModalProps) => {
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [legalServicesData, setLegalServicesData] = React.useState<any>({});
  const { activeLifestyleBenefits, updateCost, updatePlanName } =
    useContext(EnrollmentStore);

  const [radioButtonValue, setRadioButtonValue] = React.useState<
    string | number
  >(9);

  const [tellMeMore, setTellMeMore] = useState(false);

  useEffect(() => {
    const data = getAllLegalServices();

    if (data) {
      setLegalServicesData(data);
    }
  }, [legalServicesData]);

  useEffect(() => {
    const currentBenefit = activeLifestyleBenefits.find(
      (benefit: any) => benefit.type === 'legal-services'
    );
    const index = legalServicesData.plans?.findIndex(
      (plan: any) => plan.id === currentBenefit?.plan?.id
    );
    setRadioButtonValue(index);
  }, [activeLifestyleBenefits, legalServicesData]);

  const handleRadioButtonValue = (e: string | number) => {
    setRadioButtonValue(e);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const handleTellMeMore = () => {
    setTellMeMore((prev) => !prev);
  };

  return (
    <>
      {legalServicesData ? (
        <Modal
          show={showLegalServicesModal}
          onHide={handleCloseLegalServicesModal}
          dialogClassName="modal-xl"
          className="custom-health-savings-modal"
        >
          <ModalHeader
            rightButton={
              <div onClick={toggleDetails} className={'icon-button-wrapper'}>
                <IconButton
                  variant="icon-default"
                  icon={light('circle-exclamation')}
                  extLabel="Benefit Info"
                />
              </div>
            }
            leftIcon={light('gavel')}
            leftIconVariant="icon-default"
          >
            <h4 className="text-sm-20-lg-32">
              {legalServicesData['generic']
                ? legalServicesData['generic']['title']
                : ''}
            </h4>
          </ModalHeader>
          <ModalBody>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="d-flex justify-content-center">
                <DefaultCard
                  closeButton={
                    <Link 
                      className='pt-0' 
                      isAlignAtEnd 
                      isWhiteIcon 
                      rightIcon={light('close')}
                      onClick={toggleDetails}
                    />                      
                  }
                  variant="blue-motif"
                  leftHeading={
                    legalServicesData['generic']
                      ? legalServicesData['generic']['info']['title']
                      : ''
                  }
                  leftSubheading={
                    <Container className={'px-0 d-flex flex-column'}>
                      {legalServicesData['generic'] ? (
                        <>
                          <span>
                            {
                              legalServicesData['generic']['info'][
                                'description'
                              ]
                            }
                          </span>
                          {tellMeMore && (
                            <span className={'mt-1'}>
                              {
                                legalServicesData['generic']['info'][
                                  'additionalDescription'
                                ]
                              }
                            </span>
                          )}
                        </>
                      ) : (
                        ''
                      )}
                    </Container>
                  }
                  button={
                    <Button
                      onClick={handleTellMeMore}
                      variant="primary-shadow"
                      size="sm"
                    >
                      {tellMeMore ? 'Tell me less' : 'Tell me more'}
                    </Button>
                  }
                  className={'mb-12'}
                />
              </div>
            </Row>
            <Container className="p-0">
              <Row className="mb-7 mb-lg-12">
                <h5 className="text-sm-14-lg-24">
                  What option would you like?
                </h5>
              </Row>
              <Row>
                <RadioGroup
                  name={'pricing-test1'}
                  value={radioButtonValue}
                  onChange={handleRadioButtonValue}
                >
                  <div>
                    {legalServicesData['plans']
                      ? legalServicesData['plans'].map(
                          (
                            plan: {
                              title: string;
                              cost: any;
                              coverage: number;
                            },
                            i: any
                          ) => (
                            <SelectableCard
                              title={plan.title}
                              prePaydPeriod={plan.cost}
                              radioButtonValue={i}
                              selected={radioButtonValue === i}
                              disabled={
                                i === legalServicesData['plans'].length - 1
                              }
                              key={i}
                            />
                          )
                        )
                      : ''}
                  </div>
                </RadioGroup>
              </Row>
            </Container>
          </ModalBody>
          <Modal.Footer className="pt-7">
            <Button
              onMouseDown={handleCloseLegalServicesModal}
              className="text-nowrap mt-7 mt-lg-0"
              variant="primary-outline"
            >
              Cancel
            </Button>
            <Button
              onMouseDown={() => {
                updateCost(
                  'legal-services',
                  legalServicesData.plans[radioButtonValue]
                );
                updatePlanName(
                  'legal-services',
                  legalServicesData.plans[radioButtonValue]
                );
                handleCloseLegalServicesModal();
              }}
              className="text-nowrap"
              variant="primary"
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        'NO DATA'
      )}
    </>
  );
};

export default LegalServicesModal;
